export default __webpack_public_path__ + "static/github-b0544b168841322a58599a6f17e80e72.png";